var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminView',[_c('h1',{staticClass:"title-1"},[_vm._v("Étapes de réglage")]),_c('div',{staticClass:"column"},[_c('SettingsStepsForm',{attrs:{"settingsSteps":_vm.settingsSteps}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }